/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SearchEntityCounts} from '../models/SearchEntityCounts';

export interface GetSearchesEntityIdsCounts$Request {
    userId: number;
    requestBody: Array<string>;
}

export interface GetSearchesEntityIdsCounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSearchesEntityIdsCountsRequest = createAction<PayloadData<void, GetSearchesEntityIdsCounts$Request>>('USER_CONTENT_ID_COUNT__GET_SEARCHES_ENTITY_IDS_COUNTS__REQUEST');
export const getSearchesEntityIdsCountsSuccess = createAction<PayloadData<Array<SearchEntityCounts>, GetSearchesEntityIdsCounts$Request>>('USER_CONTENT_ID_COUNT__GET_SEARCHES_ENTITY_IDS_COUNTS__SUCCESS');
export const getSearchesEntityIdsCountsFailure = createAction<PayloadData<Error, GetSearchesEntityIdsCounts$Request, true>>('USER_CONTENT_ID_COUNT__GET_SEARCHES_ENTITY_IDS_COUNTS__FAILURE');

export const getSearchesEntityIdsCountsActions = [
    getSearchesEntityIdsCountsRequest,
    getSearchesEntityIdsCountsSuccess,
    getSearchesEntityIdsCountsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSearchesEntityIdsCounts = (meta: GetSearchesEntityIdsCounts$Request, config?: GetSearchesEntityIdsCounts$Config) => {
    return {
        CALL_API: {
            types: getSearchesEntityIdsCountsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/saved-searches/entity-ids/counts`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

